import { render, staticRenderFns } from "./LastEdition.vue?vue&type=template&id=7c394b8c&scoped=true&"
import script from "./LastEdition.vue?vue&type=script&lang=js&"
export * from "./LastEdition.vue?vue&type=script&lang=js&"
import style0 from "./LastEdition.vue?vue&type=style&index=0&id=7c394b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c394b8c",
  null
  
)

export default component.exports